// extracted by mini-css-extract-plugin
export var locationCard = "_qw-0";